<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
  >
    <g clip-path="url(#clip0_3004_40736)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7781 19.7782C20.1687 19.3876 20.1687 18.7545 19.7781 18.364L13.4142 12L19.7781 5.63604C20.1687 5.24552 20.1687 4.61235 19.7781 4.22183C19.3876 3.8313 18.7544 3.8313 18.3639 4.22183L12 10.5858L5.63599 4.22182C5.24547 3.8313 4.6123 3.8313 4.22178 4.22182C3.83126 4.61235 3.83126 5.24551 4.22178 5.63604L10.5857 12L4.22178 18.364C3.83125 18.7545 3.83125 19.3876 4.22178 19.7782C4.6123 20.1687 5.24547 20.1687 5.63599 19.7782L12 13.4142L18.3639 19.7782C18.7544 20.1687 19.3876 20.1687 19.7781 19.7782Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_3004_40736">
        <rect :width="width" :height="height" :fill="color" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: Number,
        default: 24,
      },
      height: {
        type: Number,
        default: 24,
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },

    computed: {
      viewBox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>
